// src/services/api.js
import { auth } from "./firebase";

function generateId() {
  return 'xxxx-xxxx-xxxx'.replace(/x/g, () => Math.floor(Math.random() * 16).toString(16));
}

// VULN-025: Sem fallback para evitar enviar tokens a domínio não controlado
const BASE = process.env.REACT_APP_API_URL;
if (!BASE) {
  console.error("REACT_APP_API_URL não configurado!");
}

/** Retorna o token Firebase do usuário atual para autenticar no backend */
async function getToken() {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado.");
  return user.getIdToken();
}

/** Wrapper de fetch autenticado */
async function apiFetch(path, options = {}) {
  const token = await getToken();
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.erro || "Erro na requisição.");
  return data;
}

/**
 * Cria um pagamento no backend → retorna link do Mercado Pago
 * @param {string} eventoId
 * @param {number} quantidade
 */
// VULN-023: Idempotency key para prevenir pagamentos duplicados
export async function criarPagamento(eventoId, quantidade = 1, payMethod = "pix", customAmount = null) {
  return apiFetch("/pagamento/criar", {
    method: "POST",
    body: { eventoId, quantidade, payMethod, customAmount },
    headers: { "X-Idempotency-Key": generateId() },
  });
}

/**
 * Busca os dados de um ingresso específico
 */
export async function buscarIngresso(ingressoId) {
  return apiFetch(`/pagamento/ingresso/${ingressoId}`);
}

/**
 * Lista todos os ingressos do usuário logado
 */
export async function meuIngressos() {
  return apiFetch("/pagamento/meus-ingressos");
}

/**
 * Cria um novo evento (organizador)
 */
export async function criarEvento(dados) {
  return apiFetch("/eventos", { method: "POST", body: dados });
}

/**
 * Atualiza um evento (organizador)
 */
export async function atualizarEvento(id, dados) {
  return apiFetch(`/eventos/${id}`, { method: "PATCH", body: dados });
}

/**
 * Exclui um evento (organizador)
 */
export async function excluirEvento(id) {
  return apiFetch(`/eventos/${id}`, { method: "DELETE" });
}

/**
 * Exclui um ingresso/participante (organizador)
 */
export async function excluirIngresso(id) {
  return apiFetch(`/pagamento/ingresso/${id}`, { method: "DELETE" });
}

/**
 * Realiza o check-in do ingresso de forma segura no backend
 */
export async function realizarCheckinBackend(ingressoId, expectedEventoId = null) {
  return apiFetch("/eventos/checkin", { method: "POST", body: { ingressoId, expectedEventoId } });
}

/**
 * Retorna a URL de autorização OAuth do Mercado Pago para um evento
 */
export async function getMpOAuthUrl(eventoId) {
  return apiFetch(`/mp/oauth/url?eventoId=${eventoId}`);
}

/**
 * Retorna o status de conexão da conta Mercado Pago de um evento
 */
export async function getMpOAuthStatus(eventoId) {
  return apiFetch(`/mp/oauth/status/${eventoId}`);
}

/**
 * Lista participantes de um evento (organizador/admin/staff)
 */
export async function buscarParticipantesEvento(eventoId) {
  return apiFetch(`/eventos/${eventoId}/participantes`);
}
